import { Cancel } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';

type TypeProps = {
  label: string;
  onDelete?: () => void;
};

export const RoleBox = ({ label, onDelete }: TypeProps) => {
  return (
    <Box
      sx={{
        padding: onDelete ? '3px 8px' : '8px 10px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#00000014',
        borderRadius: 5,
        gap: '2px',
      }}
    >
      <Typography variant='body2'>{label}</Typography>
      {onDelete && (
        <IconButton onClick={onDelete} size='small'>
          <Cancel fontSize='small' />
        </IconButton>
      )}
    </Box>
  );
};
